import { render } from "./shoppingListItem.vue?vue&type=template&id=68eff332"
import script from "./shoppingListItem.vue?vue&type=script&lang=js"
export * from "./shoppingListItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__